import React from "react";
import _ from "lodash";
import { Segment, Icon } from "semantic-ui-react";

import { renderLayout } from "schema/ThemeSet.react";
import OptionButton from "slides/components/OptionButton.react";
import RangeSlider from "slides/components/RangeSlider.react";

export default class RangeSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sliderVals: _.map(this.props.data.rangeselect, (slider) => {
                return (
                    (parseFloat(slider.maxValue) +
                        parseFloat(slider.minValue)) /
                    2
                );
            }),
            result: null,
        };
    }

    handleSlideComplete = (index, value) => {
        let sliderPos = _.cloneDeep(this.state.sliderVals);
        sliderPos[index] = value;
        this.setState({ sliderVals: sliderPos });
    };

    handleSubmit = () => {
        let formula = this.props.data.formula;
        let varMap = [
            "varA",
            "varB",
            "varC",
            "varD",
            "varE",
            "varF",
            "varG",
            "varH",
            "varI",
            "varJ",
            "varK",
            "varL",
            "varM",
            "varN",
            "varO",
            "varP",
            "varQ",
            "varR",
            "varS",
            "varT",
            "varU",
            "varV",
            "varW",
            "varX",
            "varY",
            "varZ",
        ];
        _.each(varMap, (thisVar, idx) => {
            let replacee = new RegExp(thisVar, "g");
            formula = formula.replace(replacee, this.state.sliderVals[idx]);
        });
        formula = formula.replace("&lt;", "<").replace("&gt;", ">");
        this.props.evalFormula(formula).then((data) => {
            if (!isNaN(data)) {
                let result = parseInt(data.result * 100, 0) / 100;
                this.setState({ result: result });
            } else {
                this.setState({ result: data.result });
            }
        });
    };

    handleContinue = () => {
        this.props.trackInteraction({
            correct: this.state.result,
            response: this.state.sliderVals,
        });
    };

    render() {
        let isPortrait =
            this.props.mobileView || window.innerHeight > window.innerWidth;
        let LayoutRender = renderLayout(isPortrait, this.props.layout);

        let resultBox = {
            fontSize: "1.5em",
        };

        let mappedOptions = _.map(
            this.props.data.rangeselect,
            (slider, index) => {
                return (
                    <RangeSlider
                        {...this.props}
                        index={index}
                        key={"slider-" + index}
                        slider={slider}
                        sliderValue={this.state.sliderVals[index]}
                        handleSlide={this.handleSlideComplete}
                    />
                );
            }
        );
        let mainContent = (
            <div>
                {mappedOptions}
                <br />
                <OptionButton
                    {...this.props}
                    secondary={true}
                    name="Calculate"
                    handleClick={this.handleSubmit}
                />
                {this.state.result != null && (
                    <Segment color="yellow">
                        {this.state.result &&
                            (this.state.result === "err" ? (
                                <div style={resultBox}>
                                    <Icon name="exclamation" /> Error
                                </div>
                            ) : (
                                <div style={resultBox}>
                                    <strong>Result:</strong>
                                    <br />
                                    <br />
                                    {this.state.result}
                                </div>
                            ))}
                    </Segment>
                )}
            </div>
        );
        return (
            <div className="full-height">
                <LayoutRender
                    {...this.props}
                    title={"Choose all right options:"}
                    mainContent={mainContent}
                />
            </div>
        );
    }
}
